<div class="step-side-form-container">
  <div class="signup-form-container email-setup">
    <div class="step-header">Set up email capture</div>
    <div class="step-header-second">
      Pick the option that fits how you work — or try all three. You can always come back to this.
    </div>

    <div *ngIf="loading" class="email-setup__loading">Loading options…</div>

    <div class="email-setup__options" *ngIf="!loading">
      <!-- Chrome extension -->
      <section class="email-setup__option" *ngIf="gmailAddOn">
        <div class="email-setup__option-head">
          <img class="email-setup__logo" [src]="gmailAddOn.logoURL || '../../../../assets/img/Gmail.png'" alt="Gmail">
          <div class="email-setup__option-titles">
            <div class="email-setup__option-title">Capture from Gmail</div>
            <div class="email-setup__option-desc">
              Install the Synced Chrome extension. When a bill arrives in Gmail, click the Synced button in the email to send it straight to your review queue.
            </div>
          </div>
        </div>
        <button type="button" class="ob-btn ob-btn--primary" (click)="installGmail()">
          Install from Chrome Web Store
        </button>
      </section>

      <!-- Outlook add-in -->
      <section class="email-setup__option" *ngIf="outlookAddOn">
        <div class="email-setup__option-head">
          <img class="email-setup__logo" [src]="outlookAddOn.logoURL || '../../../../assets/img/Outlook.png'" alt="Outlook">
          <div class="email-setup__option-titles">
            <div class="email-setup__option-title">Capture from Outlook</div>
            <div class="email-setup__option-desc">
              Install the Synced Outlook add-in. Right-click any bill in Outlook and send it to your review queue in one click.
            </div>
          </div>
        </div>
        <button type="button" class="ob-btn ob-btn--primary" (click)="installOutlook()">
          Install from Microsoft AppSource
        </button>
      </section>

      <!-- Forwarding address -->
      <section class="email-setup__option">
        <div class="email-setup__option-head">
          <div class="email-setup__logo email-setup__logo--mark" aria-hidden="true">@</div>
          <div class="email-setup__option-titles">
            <div class="email-setup__option-title">Forward bills by email</div>
            <div class="email-setup__option-desc">
              Forward any bill to your Synced address. Works from any email client, on any device.
            </div>
          </div>
        </div>
        <div class="email-setup__forward-row">
          <code class="email-setup__forward-addr">{{ forwardingEmail || 'Not available yet' }}</code>
          <button type="button" class="ob-btn ob-btn--primary email-setup__forward-btn"
                  [disabled]="!forwardingEmail"
                  (click)="copyForwardingEmail()">
            {{ copied ? 'Copied ✓' : 'Copy address' }}
          </button>
        </div>
        <p class="email-setup__hint">
          You can also set up an auto-forward rule in Gmail or Outlook to send bills here automatically.
        </p>
      </section>
    </div>

    <div class="email-setup__actions">
      <button type="button" class="ob-btn ob-btn--link" (click)="skip()">Skip for now</button>
      <button type="button" class="ob-btn ob-btn--primary" (click)="continue()">Continue</button>
    </div>
  </div>
</div>
